import "./Invoice.css";
import { ImageLink } from "../../utils/constants";

const InvoiceHTML = ({ data = {} }) => {
 const {
  billingAddress = {},
  shippingAddress = {},
  orderItems = [],
  subtotal = 0,
  Tax = 0,
  discount = 0,
  shippingcharge = 0,
  handlingcharge = 0,
  totalAmount = 0,
  currency = "INR",
  orderId,
  orderDate,
  status,
  payment = [],
  user = {},
 } = data;

 const isGujarat = billingAddress?.state?.toLowerCase() === "gujarat";
 const paymentDetails = payment?.[0] || {};
 const formatAmount = (amount = 0) => {
  return `${currency === "INR" ? "₹" : currency + " "}${Number(
   amount || 0
  ).toLocaleString("en-IN")}`;
 };
 const AddressBlock = ({ title, address = {} }) => {
  return (
   <div className="address-card">
    <div className="section-label">{title}</div>

    <h3>{address?.fullName || "N/A"}</h3>

    {address?.companyname && (
     <p className="address-company">{address.companyname}</p>
    )}

    <p className="address-text">
     {address?.address1 && (
      <>
       {address.address1}
       <br />
      </>
     )}

     {address?.address2 && (
      <>
       {address.address2}
       <br />
      </>
     )}

     {address?.city && (
      <>
       {address.city}
       {address?.state ? `, ${address.state}` : ""}
       <br />
      </>
     )}

     {address?.country && (
      <>
       {address.country}
       {address?.zipCode ? ` - ${address.zipCode}` : ""}
      </>
     )}
    </p>

    {address?.mobile && (
     <p>
      <strong>Mobile:</strong> {address.mobile}
     </p>
    )}

    {address?.whatsapp && (
     <p>
      <strong>WhatsApp:</strong> {address.whatsapp}
     </p>
    )}

    {address?.email && (
     <p>
      <strong>Email:</strong> {address.email}
     </p>
    )}

    {address?.GstNumber && (
     <p>
      <strong>GSTIN:</strong> {address.GstNumber}
     </p>
    )}
   </div>
  );
 };

 return (
  <div className="invoice-wrapper">
   <div className="invoice-container">
    <div className="invoice-header">
     <div className="company-info">
      <img src="/logo.webp" alt="Kekee Impex" className="invoice-logo" />
      <div className="company-details">
       <p>
        Y Block-3183, Surat Textile Market,
        <br />
        Ring Road, Surat, Gujarat - 395002, INDIA
       </p>

       <p>
        <strong>Mobile:</strong> +91 9512050402, +91 9879550402
       </p>

       <p>
        <strong>GSTIN:</strong> 24AAHFU7957B1ZZ
       </p>
      </div>
     </div>

     <div className="invoice-title">
      <h2>INVOICE</h2>

      <div className="invoice-title-line"></div>

      <p>Original for Recipient</p>
      <div className="order-number">
       <span>Order ID</span>
       <strong>{orderId || "-"}</strong>
      </div>

      <div className="order-date">
       <span>Order Date</span>
       <strong>{orderDate || "-"}</strong>
      </div>
     </div>
    </div>

    {/* ================= ORDER INFORMATION ================= */}

    <div className="order-info-bar">
     <div className="order-info-item">
      <span>Payment Method</span>
      <strong>{paymentDetails?.paymentMethod || "-"}</strong>
     </div>

     <div className="order-info-item">
      <span>Payment Status</span>
      <strong
       className={
        paymentDetails?.status === "PENDING"
         ? "status-pending"
         : "status-success"
       }
      >
       {paymentDetails?.status || "-"}
      </strong>
     </div>

     <div className="order-info-item">
      <span>Order Status</span>
      <strong>{status || "-"}</strong>
     </div>
    </div>

    {/* ================= BILLING + SHIPPING ================= */}
    <div className="addresses-section">
     <AddressBlock title="BILLING ADDRESS" address={billingAddress} />

     <AddressBlock title="SHIPPING ADDRESS" address={shippingAddress} />
    </div>

    {/* ================= CUSTOMER INFO ================= */}
    <div className="customer-info">
     <div>
      <span>Customer Name</span>
      <strong>{user?.name || billingAddress?.fullName || "-"}</strong>
     </div>

     <div>
      <span>Customer Email</span>
      <strong>{user?.email || billingAddress?.email || "-"}</strong>
     </div>

     <div>
      <span>Customer Mobile</span>
      <strong>{user?.mobile_number || billingAddress?.mobile || "-"}</strong>
     </div>
    </div>

    {/* ================= PRODUCTS ================= */}
    <div className="products-section">
     <table className="invoice-table">
      <thead>
       <tr>
        <th className="sr-column">#</th>
        <th>PRODUCT DETAILS</th>
        <th className="center-column">HSN CODE</th>
        <th className="center-column">QTY</th>
        <th className="center-column">TAX</th>
        <th className="amount-column">AMOUNT</th>
       </tr>
      </thead>

      <tbody>
       {orderItems?.length > 0 ? (
        orderItems.map((item, index) => {
         const {
          quantity,
          name,
          type,
          image,
          taxPercentage,
          productsnapshots,
         } = item;

         return (
          <tr key={item?.id || item?._id || index}>
           <td className="sr-column">{String(index + 1).padStart(2, "0")}</td>

           <td>
            <div className="product-info">
             <img
              src={ImageLink(productsnapshots?.image)}
              alt={name || "Product"}
              className="product-image"
             />

             <div className="product-content">
              <h4>{name || "-"}</h4>

              {type && <p className="product-type">{type}</p>}

              <p className="product-price">
               Price: {formatAmount(productsnapshots?.price)} × {quantity || 0}
              </p>
             </div>
            </div>
           </td>

           <td className="center-column">{item?.hsnCode || "---"}</td>

           <td className="center-column">{quantity || 0}</td>

           <td className="center-column">{parseFloat(taxPercentage) || 0}%</td>

           <td className="amount-column">
            {formatAmount(productsnapshots?.subtotal)}
           </td>
          </tr>
         );
        })
       ) : (
        <tr>
         <td colSpan="6" className="empty-products">
          No products found
         </td>
        </tr>
       )}
      </tbody>
     </table>
    </div>

    {/* ================= BOTTOM ================= */}
    <div className="invoice-bottom">
     {/* LEFT SIDE */}
     <div className="invoice-left">
      {/* BANK */}
      <div className="bank-card">
       <h3>Bank Details</h3>

       <div className="bank-row">
        <span>Bank Name</span>
        <strong>ICICI BANK</strong>
       </div>

       <div className="bank-row">
        <span>A/C No.</span>
        <strong>045905007348</strong>
       </div>

       <div className="bank-row">
        <span>IFSC</span>
        <strong>ICIC0000459</strong>
       </div>
      </div>

      {/* TERMS */}
      <div className="terms-section">
       <h3>Terms & Conditions</h3>

       <ol>
        <li>Goods once sold will not be taken back.</li>

        <li>Please give "A/C PAYEE" cheque only.</li>

        <li>
         Claims, if any, shall be lodged within 7 days of receipt of Goods.
        </li>

        <li>Interest will be charged @ 24% p.a.</li>

        <li>Subject to Surat Jurisdiction.</li>
       </ol>
      </div>
     </div>

     {/* RIGHT SUMMARY */}
     <div className="invoice-summary">
      <div className="summary-row">
       <span>Subtotal</span>
       <strong>{formatAmount(subtotal)}</strong>
      </div>

      {isGujarat ? (
       <>
        <div className="summary-row">
         <span>CGST</span>
         <strong>{formatAmount(Tax / 2)}</strong>
        </div>

        <div className="summary-row">
         <span>SGST</span>
         <strong>{formatAmount(Tax / 2)}</strong>
        </div>
       </>
      ) : (
       <div className="summary-row">
        <span>IGST</span>
        <strong>{formatAmount(Tax)}</strong>
       </div>
      )}

      <div className="summary-row">
       <span>Discount</span>
       <strong>- {formatAmount(discount)}</strong>
      </div>

      <div className="summary-row">
       <span>Shipping Charge</span>
       <strong>{formatAmount(shippingcharge)}</strong>
      </div>

      <div className="summary-row">
       <span>Handling Charge</span>
       <strong>{formatAmount(handlingcharge)}</strong>
      </div>
<div className="summary-row">
  <span>Total Quantity</span>
  <strong >
    {orderItems?.reduce(
      (total, item) => total + (Number(item?.quantity) || 0),
      0
    )}
  </strong>                                                                                                                             
</div>


      <div className="summary-total">
       <span>Total Amount</span>

       <strong>{formatAmount(totalAmount)}</strong>
      </div>
     </div>
    </div>

    {/* ================= FOOTER ================= */}
    <div className="invoice-footer">
     <p>Thank you for your business!</p>

     <span>This is a computer-generated invoice.</span>
    </div>
   </div>
  </div>
 );
};

export default InvoiceHTML;
